import { NestedEvent } from "@/types/serializers"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import axios, { AxiosError } from "axios"
import toast from "react-hot-toast"
import { captureEvent } from "@/lib/posthog"

const useEvents = () => {
  const queryClient = useQueryClient()

  const {
    mutate: createEvent,
    mutateAsync: createEventAsync,
    isPending,
  } = useMutation({
    mutationFn: async (data: { name: string }) => {
      const { data: event } = await axios.post("/api/events", data)
      return event
    },
    onSuccess: () => {
      captureEvent("event_created")
      queryClient.invalidateQueries({
        queryKey: ["events"],
      })
    },
    onError: (error: AxiosError<{ error?: string }>) =>
      toast.error(error.response?.data?.error || "Failed to create event"),
  })

  const {
    data: rawEvents,
    isLoading,
    error,
  } = useQuery({
    queryFn: async (): Promise<NestedEvent[]> => {
      const res = await axios.get("/api/events")
      return Array.isArray(res.data) ? res.data : []
    },
    queryKey: ["events"],
    staleTime: 1000 * 60 * 5,
  })
  const events = Array.isArray(rawEvents) ? rawEvents : []

  return {
    createEvent,
    createEventAsync,
    isPending,
    events,
    isLoading,
    error,
  }
}

export default useEvents
